/**
 * Validation class for Explosive Precursors form
 * */
export default class ExplosivePrecursorFormValidation {
    /**
     * Init
     */
    constructor() {
        // Document Ready for jQuery validation
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.ready);
        } else {
            this.ready();
        }
    }

    /**
     * Callback - Init methods when page been loaded
     * @return void
     */
    ready = () => {
        this.validationForm();
        this.validationReciever();
    };

    /**
     * Jquery Validation for agreement
     * @return void
     */
    validationForm = () => {
        $('#explosivePrecursorsForm').validate({
            rules: {
                customerName: {
                    required: true,
                    pattern: '^[0-9a-zA-ZÅÄÖåäöd.-]{2,25}(?: +[0-9a-zA-ZÅÄÖåäö]{2,25})+$',
                },
                customerAddress: {
                    required: true,
                    minlength: 4,
                },
                customerZipCodeAndCity: {
                    required: true,
                    pattern: '^[0-9a-zA-Zd.-]{2,20}(?: +[a-zA-ZÅÄÖåäö0-9]{2,40})+$',
                },
                customerOrganizationNumber: {
                    required: true,
                    pattern: '^[0-9d.-]{7}[0-9]{4}$',
                },
            },
            messages: {
                customerName: {
                    required: explosivesTranslation.customerNameRequired,
                    pattern: explosivesTranslation.customerNamePattern,
                },
                customerAddress: {
                    required: explosivesTranslation.customerAddressRequired,
                    minlength: explosivesTranslation.customerAddressMinLength,
                },
                customerZipCodeAndCity: {
                    required: explosivesTranslation.customerZipCodeAndCityRequired,
                    pattern: explosivesTranslation.customerZipCodeAndCityPattern,
                },
                customerOrganizationNumber: {
                    required: explosivesTranslation.customerOrganizationNumberRequired,
                    pattern: explosivesTranslation.customerOrganizationNumberPattern,
                },
            },
            submitHandler: function () {
                this.checkForm();
            },
        });
    };

    /**
     * Checking if fields are valid.
     * Adding/Removing disabled class if/or not
     * @param {*} steps
     * @return void
     */
    checkForm(steps) {
        switch (steps) {
            case 'form':
                if ($('#explosivePrecursorsForm').valid()) {
                    if (
                        document.querySelectorAll('.explosiveForm:checked').length > 0 &&
                        document.querySelectorAll('.explosivesProduct:checked').length > 0
                    ) {
                        document.getElementById('Step1Next').classList.remove('disabled');
                    }
                } else {
                    document.getElementById('Step1Next').classList.add('disabled');
                }
                break;
            case 'reciever':
                if ($('#explosiveAgreementReciever').valid()) {
                    if (
                        document.querySelector('#ReceiverPersonalNumber').value.length > 0 &&
                        document.querySelector('#ReceiverEmail').value.length > 0
                    ) {
                        document.getElementById('Step2Next').classList.remove('disabled');
                    }
                } else {
                    document.getElementById('Step2Next').classList.add('disabled');
                }
                break;
            default:
                $('#explosivePrecursorsForm').valid();
        }
    }

    /**
     * Jquery  Validation for reciever form
     * @return void
     */
    validationReciever() {
        $('#explosiveAgreementReciever').validate({
            rules: {
                ReceiverPersonalNumber: {
                    required: true,
                    pattern: '^[0-9]{12}$',
                },
                ReceiverEmail: {
                    required: true,
                    email: true,
                },
            },
            messages: {
                ReceiverPersonalNumber: {
                    required: explosivesTranslation.personalNumberRequired,
                    pattern: explosivesTranslation.personalNumberRegexPersonal,
                },
                ReceiverEmail: {
                    required: explosivesTranslation.receiverEmailRequired,
                    email: explosivesTranslation.receiverEmailFormat,
                },
            },
            submitHandler: function () {},
        });
    }
}
